import $ from "@modules/jquery";

export default () => {
    if ($(".businessFinanceQuizToolBlock").length > 0) {
        const btn = document.getElementById("QuizBtnVerify");
        const totalQuestions = document.querySelectorAll('.quiz-question-item').length;

        // Ottieni la lingua e setta ID campo hidden corretto
        const lang = document.documentElement.getAttribute('lang') || 'it';
        const hiddenFieldId = lang.toLowerCase() === 'de'
            ? 'd3271355-5065-4946-862a-29948ac7baad'
            : 'd86fb677-8249-4575-b09f-f9c3c6606b98';
        const hiddenField = document.getElementById(hiddenFieldId);

        function checkAllAnswered() {
            for (let i = 1; i <= totalQuestions; i++) {
                const checked = document.querySelector(`input[name="question-${i}"]:checked`);
                if (!checked) return false;
            }
            return true;
        }

        function toggleButton() {
            if (checkAllAnswered()) {
                btn.removeAttribute('disabled');
            } else {
                btn.setAttribute('disabled', '');
            }
        }

        const allRadios = document.querySelectorAll('input[type="radio"]');
        allRadios.forEach(radio => {
            radio.addEventListener("change", () => {
                toggleButton();
            });
        });

        btn.addEventListener("click", () => {
            const answers = {};
            for (let i = 1; i <= totalQuestions; i++) {
                const selected = document.querySelector(`input[name="question-${i}"]:checked`);
                if (selected && selected.value === "yes") {
                    answers[i] = selected.value;
                }
            }

            const answerSection = document.getElementById("AnswerSection");
            const noResults = document.getElementById("NoResults");
            const answerItems = document.querySelectorAll("#AnswerSection .quiz-answer-item");

            let anyShown = false;

            answerItems.forEach(item => {
                const showFor = item.getAttribute("data-show-for");
                const showForIds = showFor.split(",").filter(Boolean);
                const shouldShow = Object.keys(answers).some(id => showForIds.includes(id));
                item.style.display = shouldShow ? "" : "none";
                if (shouldShow) anyShown = true;
            });

            if (anyShown) {
                answerSection.classList.remove("hidden");
                if (noResults) noResults.classList.add("hidden");

                // Scroll con offset header
                const offsetTop = answerSection.getBoundingClientRect().top + window.scrollY - $('header').outerHeight();
                window.scrollTo({
                    top: offsetTop,
                    behavior: 'smooth'
                });
            } else {
                answerSection.classList.add("hidden");
                if (noResults) noResults.classList.remove("hidden");

                if (noResults) {
                    const offsetTop = noResults.getBoundingClientRect().top + window.scrollY - $('header').outerHeight();
                    window.scrollTo({
                        top: offsetTop,
                        behavior: 'smooth'
                    });
                }
            }

            // Costruisci checkbox in modale
            const allLabels = document.querySelectorAll('.quiz-answer-label');
            const visibleLabels = document.querySelectorAll('#AnswerSection .quiz-answer-item:not([style*="display: none"]) .quiz-answer-label');
            const visibleTextSet = new Set(Array.from(visibleLabels).map(label => label.textContent.trim()));

            const checkboxWrapperExisting = document.querySelector('.checkbox-wrapper-quiz-answers');
            if (checkboxWrapperExisting) checkboxWrapperExisting.remove();

            const checkboxWrapper = document.createElement('div');
            checkboxWrapper.classList.add("checkbox-wrapper-quiz-answers", "mt-6", "space-y-2");

            const checkboxGroupLabel = document.createElement("label");
            checkboxGroupLabel.className = "block font-semibold text-gray-700 mb-2";
            checkboxGroupLabel.textContent = "";
            checkboxWrapper.appendChild(checkboxGroupLabel);

            const addedLabels = new Set();
            let index = 0;

            allLabels.forEach(label => {
                const text = label.textContent.trim();
                if (addedLabels.has(text)) return;
                addedLabels.add(text);

                const id = `checkbox-quiz-answer-${index++}`;
                const checkboxDiv = document.createElement("div");
                checkboxDiv.className = "flex items-center space-x-2";

                const checkbox = document.createElement("input");
                checkbox.type = "checkbox";
                checkbox.name = "quiz-answers[]";
                checkbox.value = text;
                checkbox.id = id;
                checkbox.checked = visibleTextSet.has(text);

                const labelEl = document.createElement("label");
                labelEl.htmlFor = id;
                labelEl.textContent = text;
                labelEl.className = "p";

                checkboxDiv.appendChild(checkbox);
                checkboxDiv.appendChild(labelEl);
                checkboxWrapper.appendChild(checkboxDiv);
            });

            const emailField = document.querySelector('input[type="email"]');
            if (emailField) {
                emailField.closest(".umbraco-forms-field-wrapper").insertAdjacentElement("afterend", checkboxWrapper);
            }

            function updateHiddenField() {
                const checkedBoxes = checkboxWrapper.querySelectorAll('input[type="checkbox"]:checked');
                const values = Array.from(checkedBoxes).map(c => `[${c.value.trim()}]`);
                const joined = values.join(',');

                if (!hiddenField) return;

                const existingVal = hiddenField.value || "";

                const regex = /^\[[^\]]*\](,\[[^\]]*\])*\,?/;
                if (regex.test(existingVal)) {
                    hiddenField.value = existingVal.replace(regex, joined + ',');
                } else if (existingVal.trim().length === 0) {
                    hiddenField.value = joined;
                } else {
                    hiddenField.value = joined + ',' + existingVal;
                }
            }

            updateHiddenField();

            const checkboxes = checkboxWrapper.querySelectorAll('input[type="checkbox"]');
            checkboxes.forEach(chk => {
                chk.addEventListener('change', () => {
                    updateHiddenField();
                });
            });
        });

        toggleButton();
    }
};
